import { uuidv4 } from '../helpers/utils';
import { CumulioDashboard } from '../models/dashboard.model';
import { FilterGroup } from '../models/filters.model';

export const getFilters = <T extends CumulioDashboard>(dashboardComponent: T, iframe: HTMLIFrameElement): Promise<FilterGroup[]> => {
  if (iframe?.contentWindow) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      { action: 'getFilters', _version: dashboardComponent.VERSION, requestId },
      '*'
    );

    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      // Check if promise has been resolved after 2 seconds
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = 'getFilters request timed out.';
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2000);
    });
  }

  return Promise.reject(new Error('Cannot retrieve contentWindow.'));
};
